// utils
import {copyToClipboard} from 'methods/utils';

import ComponentElement from 'components/component-element';

function ShareModal($openModalButton) {
    this.$openModalButton = $openModalButton;
    if (!this.$openModalButton) {
        return;
    }

    ComponentElement.call(this, $openModalButton);

    // создаем модалку
    this.initModal();

    this.$openModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // если при наведение есть hint, то закрываем его и потом открываем shareModal
        this.hideActiveHint();

        this.toggle();
    });
}

ShareModal.prototype = Object.create(ComponentElement.prototype);

ShareModal.prototype.hideActiveHint = function() {
    let $hint = document.querySelector('.Hint.active');
    if ($hint) {
        $hint.classList.remove('active');
    }
}

ShareModal.prototype.initModal = function() {
    this.$shareModal = document.createElement('div');
    this.$shareModal.classList.add('share-modal', 'js-shareModal');
    document.body.appendChild(this.$shareModal);

    let recalcPosition = () => {
        let diff = 40;
        let scrollDiff = 40;
        let rect = this.$openModalButton.getBoundingClientRect();
        let top  = rect.top + diff;
        let left = rect.left;

        // top
        this.$shareModal.style.top = `${top}px`;

        // left
        let maxWidth = window.innerWidth - left - scrollDiff;

        this.$shareModal.style.left = `${left}px`;
        if (maxWidth <= this.$shareModal.offsetWidth) {
            const horizontalOffset = (window.innerWidth / 2) - (this.$shareModal.clientWidth / 2);

            this.$shareModal.style.left = `${horizontalOffset}px`;
        }
    }

    // если модалка справа не помещается, то центруем слева
    window.addEventListener('resize', recalcPosition);
    window.addEventListener('scroll', recalcPosition);
    recalcPosition();

    // клик вне модалки
    window.addEventListener('click', (e) => {
        let result = e.target.closest('.js-shareModal');

        if (!result && this.$shareModal && this.$shareModal.classList.contains('active')) {
            this.$shareModal.classList.remove('active');
            this.$openModalButton.classList.remove('disable');
        }
    });

    // инициализация модалки
    this.$shareModal.classList.add('init');

    this.setLink(location.origin + location.pathname);
}

ShareModal.prototype.toggle = function() {
    if (this.$shareModal.classList.contains('active')) {
        return this.close();
    } else {
        this.open();
    }
}

ShareModal.prototype.open = function() {
    this.emit('before:open');

    this.$shareModal.classList.add('active');
    this.$openModalButton.classList.add('disable');
}

ShareModal.prototype.setLink = function(url) {
    if (!url) {
        return false;
    }

    let shareText = document.querySelector('title').textContent + ' ' + url;
    let waText    = encodeURI(shareText);
    let maxText   = encodeURIComponent(shareText);

    this.$shareModal.innerHTML = `
        <div class="close">
            <svg class="js-close" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m12 22c5.5228 0 10-4.4772 10-10 0-5.5228-4.4772-10-10-10-5.5228 0-10 4.4772-10 10 0 5.5228 4.4772 10 10 10zm4.307-14.307c0.3906 0.39053 0.3906 1.0237 0 1.4142l-2.8928 2.8929 2.8928 2.8929c0.3906 0.3905 0.3906 1.0237 0 1.4142-0.3905 0.3905-1.0236 0.3905-1.4142 0l-2.8929-2.8929-2.8928 2.8929c-0.39052 0.3905-1.0237 0.3905-1.4142 0-0.39053-0.3905-0.39053-1.0237 0-1.4142l2.8929-2.8929-2.8929-2.8929c-0.39053-0.39053-0.39053-1.0237 0-1.4142 0.39052-0.39052 1.0237-0.39052 1.4142 0l2.8928 2.8929 2.8929-2.8929c0.3906-0.39052 1.0237-0.39052 1.4142 0z" clip-rule="evenodd" fill="#D4D2D8" fill-rule="evenodd"/>
            </svg>
        </div>
        <div class="title">Поделиться объявлением</div>
        <div class="social-buttons">
            <a target="_blank" rel="nofollow noopener" href="https://vk.com/share.php?url=${url}&noparse=true" class="social-button vk">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" fill="#48729E"/>
                    <path d="m15.785 21.622h1.1955s0.361-0.0373 0.5456-0.2229c0.1696-0.1707 0.1642-0.4909 0.1642-0.4909s-0.0234-1.4995 0.721-1.7204c0.734-0.2177 1.6764 1.4493 2.6752 2.0903 0.7553 0.4849 1.3293 0.3787 1.3293 0.3787l2.6709-0.0348s1.3972-0.0806 0.7347-1.1075c-0.0543-0.0839-0.3859-0.7597-1.986-2.1481-1.6748-1.4532-1.4504-1.2181 0.5671-3.7318 1.2285-1.5308 1.7196-2.4653 1.5661-2.8656-0.1462-0.3814-1.0498-0.2806-1.0498-0.2806l-3.0073 0.0174s-0.2231-0.0284-0.3884 0.0641c-0.1616 0.0904-0.2653 0.3016-0.2653 0.3016s-0.4762 1.1845-1.1107 2.192c-1.3391 2.1257-1.8746 2.2382-2.0935 2.106-0.5094-0.3076-0.382-1.2357-0.382-1.8952 0-2.0601 0.3342-2.9191-0.6509-3.1413-0.3269-0.0738-0.5677-0.1226-1.4037-0.1305-1.0731-0.0103-1.9811 3e-3 -2.4953 0.2385-0.3422 0.1567-0.6061 0.5056-0.4453 0.5257 0.1988 0.0248 0.6489 0.1136 0.8875 0.4171 0.3082 0.3921 0.2974 1.2722 0.2974 1.2722s0.1771 2.425-0.4136 2.7262c-0.4053 0.2066-0.9614-0.2151-2.1552-2.1437-0.6116-0.9878-1.0735-2.0799-1.0735-2.0799s-0.0889-0.204-0.24789-0.3133c-0.19269-0.1323-0.46193-0.1742-0.46193-0.1742l-2.8577 0.0173s-0.4289 0.0112-0.58652 0.1856c-0.14022 0.1552-0.0112 0.4759-0.0112 0.4759s2.2372 4.8933 4.7705 7.3592c2.3232 2.2613 4.9607 2.1129 4.9607 2.1129z" clip-rule="evenodd" fill="#fff" fill-rule="evenodd"/>
                </svg>
            </a>
            <a target="_blank" rel="nofollow noopener" href="https://t.me/share?url=${url}" class="social-button tg">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" fill="url(#paint0_linear_2626_15481)"/>
                    <path d="M5.30207 15.7048C7.34812 14.5778 9.63207 13.6372 11.7661 12.6917C15.4374 11.1432 19.1233 9.62147 22.8464 8.20477C23.5708 7.96338 24.8724 7.72731 25 8.80081C24.9301 10.3203 24.6427 11.831 24.4455 13.3416C23.945 16.6636 23.3665 19.9742 22.8024 23.2853C22.608 24.3882 21.2264 24.9591 20.3424 24.2533C18.2179 22.8183 16.077 21.3972 13.9796 19.9289C13.2925 19.2307 13.9296 18.2282 14.5432 17.7297C16.2931 16.0052 18.1488 14.5401 19.8072 12.7265C20.2545 11.6462 18.9328 12.5567 18.4968 12.8356C16.1013 14.4864 13.7644 16.238 11.2387 17.6888C9.94865 18.399 8.44502 17.7921 7.15552 17.3958C5.9993 16.9171 4.30503 16.4348 5.30195 15.7049L5.30207 15.7048Z" fill="white"/>
                    <defs>
                        <linearGradient id="paint0_linear_2626_15481" x1="12.0019" y1="1.3344" x2="4.00187" y2="20" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#37AEE2"/>
                        <stop offset="1" stop-color="#1E96C8"/>
                        </linearGradient>
                    </defs>
                </svg>
            </a>
            <a target="_blank" rel="nofollow noopener" href="https://api.whatsapp.com/send?text=${waText}" class="social-button wa">
                <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" fill="#3BE459"/>
                    <g clip-path="url(#a)">
                        <path d="m20.512 17.985c-0.2483-0.1241-1.4658-0.7225-1.6925-0.8058-0.2267-0.0825-0.3917-0.1233-0.5575 0.125-0.165 0.2467-0.6392 0.805-0.7833 0.97-0.145 0.1658-0.2892 0.1858-0.5367 0.0625-0.2475-0.125-1.0458-0.3858-1.9917-1.2292-0.7358-0.6566-1.2333-1.4675-1.3775-1.7158-0.1441-0.2475-0.0158-0.3817 0.1084-0.505 0.1116-0.1108 0.2475-0.2892 0.3716-0.4333 0.1242-0.145 0.165-0.2484 0.2475-0.4142 0.0834-0.165 0.0417-0.3092-0.0208-0.4333-0.0617-0.1242-0.5567-1.3434-0.7633-1.8392-0.2009-0.4825-0.405-0.4167-0.5567-0.425-0.145-0.0067-0.31-0.0083-0.475-0.0083s-0.4333 0.0616-0.66 0.31c-0.2275 0.2475-0.8667 0.8466-0.8667 2.0658 0 1.2183 0.8867 2.3958 1.0109 2.5617 0.1241 0.165 1.7458 2.6666 4.23 3.7391 0.5916 0.255 1.0525 0.4075 1.4116 0.5209 0.5934 0.1891 1.1334 0.1625 1.56 0.0983 0.475-0.0708 1.465-0.5992 1.6717-1.1775 0.2058-0.5783 0.2058-1.0742 0.1442-1.1775-0.0617-0.1033-0.2267-0.165-0.475-0.2892h8e-4zm-4.5183 6.1692h-0.0034c-1.4754 3e-4 -2.9238-0.3964-4.1933-1.1483l-0.3-0.1784-3.1183 0.8184 0.8325-3.04-0.19584-0.3117c-0.82488-1.313-1.2614-2.8327-1.2592-4.3833 0.00166-4.5417 3.6966-8.2367 8.2408-8.2367 2.2 0 4.2683 0.85833 5.8233 2.415 0.767 0.7638 1.3749 1.6721 1.7886 2.6724s0.6249 2.0727 0.6214 3.1551c-0.0016 4.5417-3.6966 8.2375-8.2366 8.2375zm7.01-15.248c-0.9182-0.92423-2.0107-1.657-3.2141-2.156-1.2035-0.49895-2.494-0.7541-3.7968-0.75067-5.4616 0-9.9083 4.4459-9.91 9.91-8.3e-4 1.7467 0.455 3.4517 1.3225 4.9542l-1.4058 5.1358 5.2533-1.3783c1.4533 0.7918 3.0818 1.2066 4.7367 1.2067h0.0042c5.4616 0 9.9083-4.4459 9.91-9.9109 4e-3 -1.3022-0.2502-2.5924-0.748-3.7958s-1.2292-2.2961-2.152-3.215z" clip-rule="evenodd" fill="#fff" fill-rule="evenodd"/>
                    </g>
                    <defs>
                        <clipPath id="a">
                            <rect transform="translate(6 6)" width="20" height="20" fill="#fff"/>
                        </clipPath>
                    </defs>
                </svg>
            </a>
            <a target="_blank" rel="nofollow noopener" href="https://max.ru/:share?text=${maxText}" class="social-button max">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" fill="url(#maxShareGradient)"/>
                    <path fill="#fff" d="M16.3 7.2c4.86 0 8.8 3.94 8.8 8.8 0 4.86-3.94 8.8-8.8 8.8-1.5 0-2.9-.38-4.12-1.04l-3.88 1.16 1.22-3.62A8.76 8.76 0 0 1 7.5 16c0-4.86 3.94-8.8 8.8-8.8z"/>
                    <circle cx="16.3" cy="16" r="5.15" fill="url(#maxShareGradient)"/>
                    <defs>
                        <linearGradient id="maxShareGradient" x1="2" y1="16" x2="30" y2="16" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2EE6FF"/>
                            <stop offset="1" stop-color="#7A4DFF"/>
                        </linearGradient>
                    </defs>
                </svg>
            </a>
            <a target="_blank" rel="nofollow noopener" href="https://connect.ok.ru/offer?url=${url}" class="social-button ok">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" fill="#F2720C"/>
                    <path d="m15.747 9.7099c1.1116 0 2.0156 0.90404 2.0156 2.0156 0 1.1082-0.904 2.0123-2.0156 2.0123s-2.0156-0.9041-2.0156-2.0123c0-1.1116 0.904-2.0156 2.0156-2.0156zm0 6.8805c2.6853 0 4.8683-2.183 4.8683-4.8649 0-2.6853-2.183-4.8683-4.8683-4.8683s-4.865 2.183-4.865 4.8683c0 2.6819 2.1797 4.8649 4.865 4.8649zm1.9687 3.971c0.9911-0.2277 1.9453-0.6194 2.8259-1.1719 0.6663-0.4185 0.8672-1.2991 0.4487-1.9654-0.4219-0.6696-1.2991-0.8705-1.9688-0.4486-1.9921 1.2522-4.5569 1.2522-6.5524 0-0.6663-0.4219-1.5469-0.221-1.9654 0.4486-0.4185 0.6663-0.2177 1.5469 0.4486 1.9654 0.8806 0.5525 1.8349 0.9442 2.8259 1.1719l-2.7221 2.7188c-0.5558 0.5558-0.5558 1.4598 0 2.0156 0.2813 0.2779 0.6429 0.4185 1.0079 0.4185 0.3649 0 0.7299-0.1406 1.0111-0.4185l2.6719-2.6719 2.6752 2.6719c0.5558 0.5591 1.4565 0.5591 2.0156 0 0.5558-0.5558 0.5558-1.4598 0-2.0156l-2.7221-2.7188z" fill="#fff"/>
                </svg>
            </a>
        </div>
        <input class="share-text js-shareText" type="text" disabled value="${url}" />
        <button class="share-button js-shareButton">Скопировать ссылку</button>
    `;
    this.$shareText = this.$shareModal.querySelector('.js-shareText');

    // кнопка поделиться в модалке
    this.$shareButton = this.$shareModal.querySelector('.js-shareButton');
    this.$shareButton.addEventListener('click', () => {
        copyToClipboard(this.$shareModal.querySelector('.js-shareText').value);
        this.$shareButton.textContent = 'Скопировано!';

        clearTimeout(this._shareCopyLinkTimeout);
        this._shareCopyLinkTimeout = setTimeout(() => {
            this.$shareButton.textContent = 'Скопировать ссылку';
        }, 5000)
    });

    // выделение ссылки поделится
    this.$shareText.addEventListener('click', function(e) {
        e.preventDefault();

        e.target.select();
        e.target.setSelectionRange(0, 99999); /* For mobile devices */

        document.execCommand("copy");
    });

    // закрытие модалки
    this.$shareModal.querySelector('.js-close').addEventListener('click', this.close.bind(this));
}

ShareModal.prototype.close = function() {
    this.emit('before:close');

    this.$shareModal.classList.remove('active');
    this.$openModalButton.classList.remove('disable');
}

export default ShareModal;
